function applyRichTextWrapperLinkTypes(root = document) {
  // const wrappers = root.querySelectorAll(".rich-text__wrapper");
  // wrappers.forEach((wrapper) => {
  //   const linkTypeClass = Array.from(wrapper.classList).find((cl) =>
  //     cl.startsWith("link-type-")
  //   );
  //   if (!linkTypeClass) return;
  //   wrapper.querySelectorAll("a").forEach((a) => {
  //     const hasAnyLinkType = Array.from(a.classList).some((cl) =>
  //       cl.includes("link-type-")
  //     );
  //     if (!hasAnyLinkType) a.classList.add(linkTypeClass);
  //   });
  // });

  document.querySelectorAll("a").forEach((a) => {
    const hasAnyLinkType = Array.from(a.classList).some((cl) =>
      cl.includes("link-type-")
    );
    if (!hasAnyLinkType) {
      const parentWithLinkType = a.closest('[class*="link-type-"]');
      if (parentWithLinkType) {
        const linkTypeClass = Array.from(parentWithLinkType.classList).find(
          (cl) => cl.startsWith("link-type-")
        );
        a.classList.add(linkTypeClass);
      }
    }
  });
}

function processLinkType2(root = document) {
  root.querySelectorAll("a.link-type-2").forEach((link) => {
    if (link.dataset.linkType2Processed === "true") return;
    // Skip buttons and complex HTML links
    if (
      link.classList.contains("button") ||
      link.closest(".button") ||
      link.matches(
        ".button, .button--primary, .button--secondary, .shopify-payment-button__button"
      ) ||
      link.querySelector("*")
    ) {
      link.dataset.linkType2Processed = "true"; // mark to avoid repeated checks
      return;
    }
    link.innerHTML =
      "<div><span>" +
      link.textContent.trim().split("").join("</span><span>") +
      "</span></div>";
    link.querySelectorAll("span").forEach((s, i) => {
      s.innerHTML = s.textContent == " " ? "&nbsp;" : s.textContent;
      s.style.transitionDelay = `${(i + 1) / 20}s`;
    });
    link.insertAdjacentHTML(
      "beforeend",
      '<div><svg preserveAspectRatio="none" viewBox="0 0 192 5"><path d="M191.246 4H129C129 4 127.781 4.00674 127 4C114.767 3.89447 108.233 1 96 1C83.7669 1 77.2327 3.89447 65 4C64.219 4.00674 63 4 63 4H0.751923" /></svg></div>'
    );
    link.dataset.linkType2Processed = "true";
  });
}

function bindLinkType4(root = document) {
  root.querySelectorAll("a.link-type-4").forEach((link) => {
    if (link.dataset.linkType4Bound === "true") return;
    if (
      link.classList.contains("button") ||
      link.closest(".button") ||
      link.matches(
        ".button, .button--primary, .button--secondary, .shopify-payment-button__button"
      )
    ) {
      link.dataset.linkType4Bound = "true";
      return;
    }
    link.addEventListener("mouseenter", function () {
      const rect = this.getBoundingClientRect();
      const x_pos = rect.left + (window.scrollX || window.pageXOffset);
      const y_pos = rect.top + (window.scrollY || window.pageYOffset);
      const translate = `translate(${x_pos}px, ${y_pos}px)`;
      const underlines = document.querySelectorAll(".underline_link-type-4");
      underlines.forEach((underline) => {
        underline.style.transform = `${translate}`;
        underline.style.width = rect.width + "px";
        underline.style.height = rect.height + "px";
      });
    });
    link.addEventListener("mouseleave", function () {
      const underlines = document.querySelectorAll(".underline_link-type-4");
      underlines.forEach((underline) => {
        underline.style.transform = `unset`;
        underline.style.width = 1 + "px";
        underline.style.height = 1 + "px";
      });
    });
    // Keyboard accessibility
    link.addEventListener("focus", function () {
      const rect = this.getBoundingClientRect();
      const x_pos = rect.left + (window.scrollX || window.pageXOffset);
      const y_pos = rect.top + (window.scrollY || window.pageYOffset);
      const translate = `translate(${x_pos}px, ${y_pos}px)`;
      const underlines = document.querySelectorAll(".underline_link-type-4");
      underlines.forEach((underline) => {
        underline.style.transform = `${translate}`;
        underline.style.width = rect.width + "px";
        underline.style.height = rect.height + "px";
      });
    });
    link.addEventListener("blur", function () {
      const underlines = document.querySelectorAll(".underline_link-type-4");
      underlines.forEach((underline) => {
        underline.style.transform = `unset`;
        underline.style.width = 1 + "px";
        underline.style.height = 1 + "px";
      });
    });
    link.dataset.linkType4Bound = "true";
  });
}

function applyAll(root = document) {
  applyRichTextWrapperLinkTypes(root);
  // Fallback: body data attribute applies type if none set
  if (document.body && document.body.dataset.linkAnimation !== "") {
    root.querySelectorAll("a").forEach((link) => {
      if (!Array.from(link.classList).find((cl) => cl.includes("link-type-"))) {
        link.classList.add(document.body.dataset.linkAnimation);
      }
    });
  }
  processLinkType2(root);
  bindLinkType4(root);
}

window.addEventListener("DOMContentLoaded", () => {
  applyAll(document);
});

document.addEventListener("shopify:section:load", (e) => applyAll(e.target));
document.addEventListener("shopify:section:select", (e) => applyAll(e.target));
